<section class="xchange-loader" [style.top]="fullScreen ? 0 : height" [style.background-color]="spinnerBackgroundColor">
    <div  class="custom-spinner" [style.background-color]="spinnerBackgroundColor"></div>
</section>